export default __webpack_public_path__ + "static/1-4047f16cb75b2698a953eaf1d37f026c.svg";